import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPolygon } from 'shared/common/types/polygons';

const initialState: IPolygon = { value: 2000, label: 'Москва' };

/* istanbul ignore next */
const selectedPolygonSlice = createSlice({
  initialState,
  name: 'polygon',
  reducers: {
    setSelectedPolygon: (state, action: PayloadAction<IPolygon>) => {
      state.label = action.payload.label;
      state.value = action.payload.value;
    },
  },
});

export const {
  reducer: selectedPolygonReducer,
  actions: { setSelectedPolygon },
} = selectedPolygonSlice;
